
import Hero from "../components/hero/Hero";

export default function HomePage() {
  return( <div>
    <Hero/>
    </div>
    );
}

